import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewCardShell, { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';

const OperationalMiniCard = ({ title, status, actionLabel, route }) => {
    const navigate = useNavigate();

    return (
        <OverviewCardShell
            title={title}
            className={styles.operationalCard}
            footer={<OverviewTextAction onClick={() => navigate(route)}>{actionLabel}</OverviewTextAction>}>
            <p className={styles.operationalStatus}>{status}</p>
        </OverviewCardShell>
    );
};

export default OperationalMiniCard;
